export default {
  state: {
    editPaper: {}, // 正在编辑的试卷
    question: {}, // 正在编辑的题目
  },
  mutations: {
    updatePaper(state, paper){
      state.editPaper = paper
    },
    updateQuestion(state, question){
      state.question = question
    }
  },
  actions: {
    
  }
}


// WEBPACK FOOTER //
// ./src/store/module/exam.js